import { gql } from "@apollo/client";

export const importProductsMutation = gql`
  mutation ImportProducts($input: ImportProductsInput!) {
    importProducts(input: $input) {
      importFile {
        id
        status
      }
      importErrors {
        field
        message
        code
      }
    }
  }
`;

export const importImageUploadMutation = gql`
  mutation ImportImageUpload($files: [Upload!]!) {
    importImageUpload(files: $files) {
      uploadedCount
      results {
        filename
        saved
        status
        matchedCount
        message
      }
      importErrors {
        field
        message
        code
      }
    }
  }
`;
